/* Scoped controls for the optional 55carat banner, including Shopify editor reloads. */
(() => {
  'use strict';
  if (window.CaratRingBanner) { window.CaratRingBanner.init(document); return; }
  const names = {sapphire:'BLUE SAPPHIRE', emerald:'EMERALD', ruby:'RUBY', yellow:'YELLOW SAPPHIRE'};
  const mounted = new WeakMap();
  const roots = scope => [...(scope.matches?.('[data-carat-banner]') ? [scope] : []), ...scope.querySelectorAll('[data-carat-banner]')];
  function init(scope = document) {
    for (const root of roots(scope)) {
      if (mounted.has(root)) continue;
      const ring = root.querySelector('carat-ring');
      if (!ring) continue;
      const controller = new AbortController();
      mounted.set(root, controller);
      const listen = (el, name, fn) => el?.addEventListener(name, fn, {signal:controller.signal});
      const pause = root.querySelector('[data-carat-pause]');
      const auto = root.querySelector('[data-carat-auto]');
      const status = root.querySelector('[data-carat-status]');
      const renderSelection = stone => {
        const label = root.querySelector('[data-carat-label]');
        if (label) label.textContent = (names[stone] || names.sapphire) + ' · 925 STERLING SILVER';
        const number = root.querySelector('[data-carat-number]');
        if (number) number.textContent = '0' + (Object.keys(names).indexOf(stone) + 1) + ' / 04';
        root.querySelectorAll('[data-carat-stone]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.caratStone === stone)));
      };
      const renderMotion = () => {
        if (pause) { const paused = ring.hasAttribute('paused'); pause.textContent = paused ? 'Resume animation' : 'Pause animation'; pause.setAttribute('aria-pressed', String(paused)); }
        if (auto) { const enabled = ring.hasAttribute('cycle'); auto.textContent = 'Auto showcase: ' + (enabled ? 'on' : 'off'); auto.setAttribute('aria-pressed', String(enabled)); }
      };
      for (const button of root.querySelectorAll('[data-carat-stone]')) listen(button, 'click', () => {
        ring.removeAttribute('cycle');
        renderMotion();
        if (status) status.textContent = 'Loading ' + names[button.dataset.caratStone].toLowerCase() + '…';
        ring.setAttribute('stone', button.dataset.caratStone);
      });
      listen(pause, 'click', () => { ring.toggleAttribute('paused'); renderMotion(); });
      listen(auto, 'click', () => { ring.toggleAttribute('cycle'); renderMotion(); });
      listen(ring, 'ring-change', event => {
        renderSelection(event.detail.stone);
        if (status) status.textContent = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'Static view · Reduced motion respected.' : matchMedia('(hover: hover) and (pointer: fine)').matches ? 'Gentle motion · Move your pointer across the ring' : 'Gentle motion · Soft light and gemstone colours';
      });
      listen(ring, 'ring-error', () => { if (status) status.textContent = 'A ring image could not load. Select another stone or refresh.'; });
      listen(root.querySelector('[data-carat-scroll]'), 'click', event => {
        const heading = [...document.querySelectorAll('h2,h3')].find(el => !root.contains(el) && el.textContent.trim().toLowerCase() === 'jewellery to wear every day');
        if (!heading) return; // Use the existing collection link when no local section is present.
        event.preventDefault();
        const target = heading.closest('section,[id^="shopify-section-"]') || heading;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll:true});
      });
      renderSelection(ring.getAttribute('stone') || 'sapphire');
      renderMotion();
    }
  }
  function dispose(scope) { for (const root of roots(scope)) { mounted.get(root)?.abort(); mounted.delete(root); } }
  window.CaratRingBanner = {init, dispose};
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => dispose(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
})();
